import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconStaywallet: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16.7264 5.39919C16.8903 4.94784 16.9946 4.48144 17.0244 4L19.8994 4.01505C19.8994 4.84051 19.5407 6.2816 18.8774 7.74138C18.9695 7.90239 19.0559 8.06605 19.1365 8.23208C19.7139 9.37945 20.0139 10.6624 19.9887 11.974C20.0036 12.1695 20.0036 12.3802 19.9887 12.5758C19.81 16.8486 16.2348 20.1735 12.0042 19.993H11.4084C7.16289 19.8425 3.85588 16.2468 4.00484 11.974C3.93036 9.29593 5.22635 6.76836 7.43103 5.2789L9.11432 7.89674C7.9375 8.91981 7.28206 10.4243 7.32675 11.989C7.31186 12.1244 7.31185 12.2448 7.31185 12.3802C7.32675 14.983 9.41225 17.0742 11.9744 17.0742C12.1234 17.0742 12.2575 17.0742 12.4064 17.0592C14.5238 16.8716 16.1884 15.2702 16.5615 13.2574C16.5266 13.2344 16.5109 13.203 16.518 13.1625C16.6362 12.4909 16.6518 11.8046 16.5648 11.1328C16.0951 11.5698 15.5817 11.9243 15.0282 12.1544C14.5813 12.335 14.0898 12.4403 13.5982 12.4403C12.481 12.4102 11.4382 11.9288 10.6934 11.0862C9.3527 9.53659 9.36759 7.21965 10.7083 5.68505C11.8404 4.37613 13.9706 3.66901 16.7264 5.39919ZM12.0638 8.36307C12.0638 9.37109 12.8832 10.1986 13.8812 10.1986C14.8793 10.1986 15.6986 9.38614 15.6986 8.36307C15.6986 7.35505 14.8793 6.52757 13.8812 6.52757C12.8832 6.52757 12.0638 7.35505 12.0638 8.36307Z',
    })
  )
}
